// Define multiple base URLs as an object
const BASE_URLS = {
  WebUrl: "/",
};

export default BASE_URLS;
